// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homepage-responsive{flex:1}@media screen and (max-width: 1100px){.instance-home-widget-search-bar{width:100%;top:4rem;padding-bottom:3rem}.recommendation-card{margin-left:0px !important;margin-right:0px !important}.recommendation-widget-main{padding:0px 2rem 3rem 2rem}}", ""]);
// Exports
module.exports = exports;
